export const errorChangeEvent = (name: string) => `${name}_ERROR_CHANGE`;
